const REVOKE_DELAY_MS = 30 * 1000;

/** Saves `data` to the user's disk as `filename`, revoking the object URL once the download started */
export const saveBlob = (data: BlobPart, filename: string, type?: string): void => {
  const blob = type !== undefined ? new Blob([data], { type }) : new Blob([data]);
  const anchor = document.createElement('a');
  anchor.download = filename;
  anchor.href = URL.createObjectURL(blob);
  anchor.addEventListener('click', () => {
    setTimeout(() => {
      URL.revokeObjectURL(anchor.href);
    }, REVOKE_DELAY_MS);
  });
  anchor.click();
};
